'use client';

import { c as _c } from "react/compiler-runtime";
import { isEnumValue } from '@core/utils';
import { useSearchParams } from 'next/navigation';
import { PageNavigation } from '@/components/client';
import { CATEGORY_LIST_KEY, CategorySwiper, QUERY_STRING_KEY_MY_INFO_SCRAP_CATEGORY } from './_components/CategorySwiper';
import { EmergencyScrapList } from './_components/EmergencyScrapList';
import { FestivalScrapList } from './_components/FestivalScrapList';
import { HometownNewsScrapList } from './_components/HometownNewsScrapList';
import { PolicyInfoScrapList } from './_components/PolicyInfoScrapList';
import { PolicyScrapList } from './_components/PolicyScrapList';
import { WelloNewsScrapList } from './_components/WelloNewsScrapList';
const MyScrapPage = () => {
  const $ = _c(14);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    const categorySearchParams = searchParams.get(QUERY_STRING_KEY_MY_INFO_SCRAP_CATEGORY);
    t0 = isEnumValue(CATEGORY_LIST_KEY, categorySearchParams) ? categorySearchParams : CATEGORY_LIST_KEY.POLICY;
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const category = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PageNavigation backButton={true} className="pb-8" title={"\uC2A4\uD06C\uB7A9 \uBAA9\uB85D"} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== category) {
    t2 = <CategorySwiper selectedCategory={category} />;
    $[3] = category;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PolicyScrapList />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <EmergencyScrapList />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <HometownNewsScrapList />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <WelloNewsScrapList />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <PolicyInfoScrapList />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      [CATEGORY_LIST_KEY.POLICY]: t3,
      [CATEGORY_LIST_KEY.EMERGENCY]: t4,
      [CATEGORY_LIST_KEY.HOMETOWN_NEWS]: t5,
      [CATEGORY_LIST_KEY.WELLO_NEWS]: t6,
      [CATEGORY_LIST_KEY.POLICY_INFO]: t7,
      [CATEGORY_LIST_KEY.FESTIVAL]: <FestivalScrapList />
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = t8[category];
  let t10;
  if ($[11] !== t2 || $[12] !== t9) {
    t10 = <article className="flex w-full flex-col pt-40 mobile-tablet:pt-0">{t1}{t2}{t9}</article>;
    $[11] = t2;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  return t10;
};
export default MyScrapPage;